<script setup lang="ts">
import { computed, type PropType } from 'vue'
import type { CabinetMeterType } from './../model/types'

const props = defineProps({
  meter: {
    type: Object as PropType<CabinetMeterType>,
    required: true,
  },
})

/* Вычисляем класс для иконки статуса */
const statusClass = computed(() => {
  switch (Number(props.meter.is_connected)) {
    case 0:
      return 'w-cabinet-meter__status_error'
    case 1:
      return 'w-cabinet-meter__status_success'
    case 2:
      return 'w-cabinet-meter__status_warning'
  }
})
</script>

<template>
  <div class="w-cabinet-meter__header">
    <div class="w-cabinet-meter__status" :class="statusClass"></div>

    <span>{{ $t('itf.meter') }} №{{ meter.serial_number }}</span>
  </div>
</template>
